import {
  CheckHirist,
  CheckIcon,
  ChevronDown,
  UnCheckIcon,
} from '@jobseeker/lotus/assets/icons';
import ButtonV2 from '@jobseeker/lotus/elements/ButtonV2';
import {OptionType} from '@jobseeker/lotus/elements/Select';
import Tooltip from '@jobseeker/lotus/elements/Tooltip';
import {
  Box,
  Button,
  ClickAwayListener,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import {info2} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';

import {useRef, useState} from 'react';
import {PiSlidersFill} from 'react-icons/pi';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

const FilterIcon = styled(PiSlidersFill)(() => ({
  height: '16px',
  width: '16px',
  transform: 'rotate(-90deg)',
}));
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const Checkbox = ({checked}: any) => {
  return (
    <Image
      src={checked ? (isAppIimjobs ? CheckIcon : CheckHirist) : UnCheckIcon}
      alt="checkbox"
      width={16}
      height={16}
      style={{
        marginLeft: '16px',
        marginRight: '8px',
        marginTop: '11px',
        marginBottom: '11px',
      }}
    />
  );
};

type Props = {
  selectedValues: any[];
  options: OptionType[];
  handleSelectChange: (event: SelectChangeEvent<number[]>) => void;
  applyFilters: () => void;
};

const Filter = (props: Props) => {
  const theme = useWrappedTheme();
  const {selectedValues, handleSelectChange, options, applyFilters} = props;
  const [open, setOpen] = useState(false);
  const SelectIcon = ({className, open}: any) => {
    const theme = useTheme();
    return (
      <Image
        className={className}
        src={ChevronDown}
        alt={'Drop Down Arrow'}
        width={12}
        height={12}
        style={{
          userSelect: 'none',
          padding: '2px',
          zIndex: open ? 2 : 0,
          marginRight: theme.spacing(2),
          marginLeft: theme.spacing(1.7),
          marginTop: theme.spacing(0.3),
          transition: '0.3s ease-in-out',
        }}
        objectFit="cover"
      />
    );
  };
  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (open) setOpen(false); // Close menu explicitly
  };
  const handleSelectClick = () => {
    setOpen(prev => !prev); // Toggle open state
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box>
        {isAppIimjobs ? (
          <>
            <Typography
              display="flex"
              justifyContent="flex-end"
              marginRight={15.75}
              sx={{
                variant: 'body2',
                fontSize: 12,
                fontWeight: 500,
                color: '#333',
                mt: 2.25,

                mb: 1.125,
              }}
            >
              Filter by Application Status&nbsp;
              <Tooltip
                arrow
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [-125, 0], // Move 10px to the left
                      },
                    },
                  ],
                }}
                title={
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 0,
                        maxWidth: 304,
                      }}
                    >
                      Want to know what happened to your applications? Get real
                      time updates as soon as a recruiter performs an action on
                      your application.
                    </Typography>
                  </Box>
                }
              >
                <span style={{display: 'inline-flex', alignItems: 'center'}}>
                  <Image
                    style={{marginTop: 1.5}}
                    src={info2}
                    height={12}
                    width={12}
                    alt="info"
                  />
                </span>
              </Tooltip>
            </Typography>
          </>
        ) : (
          <></>
        )}
        <Grid
          container
          marginRight={isAppIimjobs ? 2 : 0}
          mt={isAppIimjobs ? 0 : '18px'}
        >
          {!isAppIimjobs ? (
            <Grid item xxs={12} sm={'auto'} md={'auto'}>
              <Typography
                sx={{fontSize: 14, fontWeight: 600, mt: '6px', mr: 1}}
              >
                Filter By:
              </Typography>
            </Grid>
          ) : (
            <></>
          )}
          <Grid
            item
            xxs={12}
            sm={'auto'}
            md={'auto'}
            sx={{
              mr: 1,
              width: 192,
            }}
          >
            <FormControl
              sx={{
                width: 192,
              }}
            >
              {' '}
              <Select
                open={open}
                // onOpen={() => setOpen(true)}
                // onClose={() => setOpen(false)}
                labelId="custom-select-label"
                multiple
                onClick={handleSelectClick}
                IconComponent={({...iconProps}) => (
                  <SelectIcon {...iconProps} open={open} />
                )}
                value={selectedValues}
                onChange={handleSelectChange}
                autoFocus={false}
                renderValue={selected => {
                  if (
                    !selected ||
                    selected.length === 0 ||
                    selected.length === 8
                  ) {
                    return (
                      <Typography
                        marginTop="0px"
                        marginLeft="-24px"
                        display="flex"
                        justifyContent="center"
                        fontSize={14}
                        fontWeight={500}
                        color={isAppIimjobs ? 'currentColor' : 'rgba(0,0,0,.5)'}
                        fontFamily={isAppIimjobs ? 'poppins' : 'Nunito Sans'}
                      >
                        All Applications
                      </Typography>
                    ); // Default text when no value is selected
                  }
                  return (
                    <Typography
                      marginTop="0px"
                      marginLeft="-60px"
                      display="flex"
                      justifyContent="center"
                      fontSize={14}
                      fontWeight={500}
                      fontFamily={isAppIimjobs ? 'poppins' : 'Nunito Sans'}
                      color={isAppIimjobs ? 'currentColor' : 'rgba(0,0,0,.5)'}
                    >{`${selected.length} selected`}</Typography>
                  );
                }}
                displayEmpty
                sx={{
                  borderRadius: 8,
                  width: 192,
                  height: 35,
                  marginTop: 0,
                  paddingTop: 0,
                  backgroundColor: isAppIimjobs ? 'transparent' : '#fff',

                  // Default border
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(126, 126, 126, 0.20)', // Default blurred border color
                    borderWidth: '1px', // Consistent border width
                  },

                  // Focus state
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(126, 126, 126, 0.20)', // Focused border color
                    borderWidth: '1px', // Consistent width
                  },

                  // Hover state
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(126, 126, 126, 0.20)', // Hover border color
                    borderWidth: '1px', // Consistent width
                  },

                  // Remove outline effect (blue highlight) from Material-UI
                  '&.MuiOutlinedInput-root': {
                    outline: 'none', // Remove blue outline
                    '&.Mui-focused': {
                      outline: 'none', // Ensure no outline appears on focus
                    },
                  },

                  // Dropdown menu (Paper component)
                  '.MuiPaper-elevation': {
                    boxShadow: 'none',
                    border: '1px solid rgba(126, 126, 126, 0.20)', // Consistent border
                    borderRadius: 2,
                    marginTop: 0.7,
                  },
                  '.MuiPopover-root': {
                    pointerEvents:
                      'none' /* Prevent the dropdown from capturing events */,
                  },

                  '.MuiMenu-list': {
                    pointerEvents: 'auto' /* Enable events on visible items */,
                  },
                }}
                variant="outlined"
                MenuProps={{
                  disablePortal: true,
                  onClick: handleSelectClick,
                  PaperProps: {
                    style: {
                      maxHeight: 392,
                      width: 192,
                      marginTop: '8px', // Ensure dropdown is below the button
                      pointerEvents: 'auto',
                      border: '1px solid rgba(126, 126, 126, 0.20)',
                      borderRadius: 8,
                      zIndex: 2,
                    },
                  },
                  TransitionProps: {
                    onEntering: element => {
                      element.style.marginTop = '8px'; // Adjusts the gap between the select and menu
                    },
                  },
                }}
              >
                {options.map(option => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                      display: 'flex',
                      gap: '12px',
                      padding: 0,
                      margin: 0,

                      // Default selected state
                      '&.Mui-selected': {
                        background: isAppIimjobs
                          ? 'var(--light-green, rgba(145, 184, 121, 0.40))'
                          : 'transparent',
                      },

                      // Hover state
                      '&:hover': {
                        background: isAppIimjobs
                          ? 'var(--light-green, rgba(145, 184, 121, 0.40))'
                          : 'transparent', // Custom hover background
                      },

                      // Selected and hover state
                      '&.Mui-selected:hover': {
                        background: isAppIimjobs
                          ? 'var(--light-green, rgba(145, 184, 121, 0.40))'
                          : 'transparent',
                      },
                    }}
                  >
                    <Checkbox
                      checked={selectedValues.indexOf(option.value) > -1}
                    />
                    <ListItemText
                      primary={option.label}
                      sx={{marginLeft: '-12px'}}
                      primaryTypographyProps={{
                        fontSize: 14,
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xxs={12} sm={'auto'} md={'auto'}>
            {/* Filter Button */}
            {isAppIimjobs ? (
              <ButtonV2
                type="submit"
                variant="outlined"
                sx={{
                  zIndex: 4,
                  width: {xxs: 'fit-content', md: '100%'},
                  fontSize: {xxs: 12, xs: 16},
                  lineHeight: {xxs: '12px', xs: '16px'},

                  '.MuiButton-startIcon': {
                    mr: {xxs: 0.5, md: 1},
                  },
                  ':hover': {
                    backgroundColor: 'secondary.main',
                    borderColor: 'secondary.main',
                    '.searchbar-icon': {
                      filter: 'brightness(10)',
                    },
                    color: '#fff',
                    '*': {
                      color: '#fff',
                    },
                  },
                }}
                onClick={applyFilters}
                startIcon={<FilterIcon className="searchbar-icon" />}
              >
                {'Filter'}
              </ButtonV2>
            ) : (
              <Button
                disableRipple
                disableFocusRipple
                onClick={applyFilters}
                sx={{
                  zIndex: 4,

                  border: `1px solid ${theme.palette.primary.main}`,
                  borderRadius: '16px',
                  padding: '5px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'background-color 0.3s ease-in-out',
                  '&:hover': {
                    backgroundColor: theme.palette.primary.main,
                    color: '#fff !important',
                    '& img': {
                      filter: 'brightness(0) invert(1)', // Turns image white
                    },
                    '& .text': {
                      color: '#fff', // Changes Typography color
                    },
                  },
                }}
              >
                <Typography
                  className="text" // Assigning class for better targeting
                  sx={{
                    fontFamily: 'Nunito Sans',
                    fontSize: 14,
                    color: theme.palette.primary.main,
                    fontWeight: 600,
                    transition: 'color 0.3s ease-in-out',
                  }}
                >
                  Apply{' '}
                </Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </ClickAwayListener>
  );
};

export default Filter;
